import styled from '@emotion/styled'

export const StickyWrapper = styled.div`
  position: sticky;
  bottom: 0;
  will-change: transform; /* move element to it's own paint layer for better rendering performance */
  z-index: 1;
`
